<template>
  <div class="toggle-container d-flex w-100">
    <span v-if="label" class="toggle-label">{{ label }}</span>
    <toggle-button
      class="toggle-button"
      :value="value"
      :color="toogleColors"
      :sync="true"
      :disabled="disabled"
      @change="toggle"
    />
  </div>
</template>

<script>
export default {
  name: 'Toggle',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      toogleColors: { checked: '#00E4F5', unchecked: '#D3D3D3' },
    }
  },
  methods: {
    toggle() {
      this.$emit('toggle', !this.value)
    },
  },
}
</script>

<style lang="scss" scoped>
.toggle-container {
  height: 20px;
  box-sizing: content-box;

  .toggle-label {
    margin-right: 10px;
    line-height: 20px;
  }
}

.toggle-button {
  /deep/ {
    .v-switch-core {
      border-radius: 2px !important;

      .v-switch-button {
        border-radius: 1px;
      }
    }
  }
}
</style>
